module.exports = __webpack_public_path__ + "7638fb3f.jpg";